import { createSelector } from 'reselect';

export const avaivableCountSelector = createSelector(
  [state => state.freeSauces],
  ({ freeCount, freeAddedCount }) => {
    return freeCount - freeAddedCount;
  },
);
